import * as React from 'react'

import './index.css'

class Loading extends React.Component {
  state = {
    activeCls: 'active'
  }
  
  render() {
    let { activeCls } = this.state
    let { thumbnail, process, sceneName } = this.props
    if (process >= 1) {
      activeCls = ''
    }
    let styleObj = {}
    if (thumbnail) {
      styleObj.style = { backgroundImage: `url(${thumbnail})` }
    }
    let curProcess = `${200 * process}px`
    return (
      <div className={`loading container ${activeCls}`} {...styleObj}>
        <h3 className="name">{sceneName}</h3>
        <div className="process-container">
          <div className="process" style={{width: curProcess}}></div>
        </div>
      </div>
    )
  }
}

export default Loading



// WEBPACK FOOTER //
// ./src/Components/Loading/index.js